export class FBControlsSectionLayoutComponent {
  constructor() {}

  static PROPERTIES() {
    return Object.freeze({
      common: {
        referenceName: { type: 'string', source: 'control.name' },
        label: { type: 'string', source: 'control.title' },
        hidden: { type: 'boolean', source: 'control.properties.hidden' },
        disabled: { type: 'boolean', source: 'control.properties.disabled' },
      },
    });
  }
}
